import { Component, Input, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import {
  DialogResponse,
  VS_LAUNCH_CALLER,
} from '../../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'app-accept-quote-dialog',
  templateUrl: './accept-quote-dialog.component.html',
  styleUrls: ['./accept-quote-dialog.component.scss'],
})
export class AcceptQuoteDialogComponent implements OnInit {
  warningMsg: any
  constructor(private launchDialogService: LaunchDialogService) {}
  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {
      this.warningMsg = data.warningMsg
    })
  }

  closeModal(message): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.ACCEPT_QUOTE,
      reason: message,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
